import React from "react";


const ReservationExternalStepFinish = (props) => {

    return <>
        <div className={'text-center py-5'}>
            <i className="fas fa-check-circle text-primary fs-1 mb-3"></i>
            <h1 className={'h5 text-uppercase my-4'}>
                Rezervace byla úspěšně odeslána.
            </h1>
            <p>
                Na e-mail jsme vám právě odeslali potvrzení a další informace.
            </p>
        </div>
    </>;

};

export default ReservationExternalStepFinish;